import {inject, onBeforeMount, onMounted, provide, reactive, ref, Ref, UnwrapRef} from "vue";

export const createStore = <State extends object, Methods extends object = {}>() => {
  type Store = { state?: State } & Methods;
  const key = Symbol();


  const provideStore = (config: {
    initState: () => State | Promise<State>,
    methods: Methods
  }) => {
    const loading = ref(true)
    const state = ref<State | undefined>(undefined);

    const store = reactive<Store>({
      ...config.methods
    })

    provide(key, store)

    onBeforeMount(async () => {
      const initState = config.initState();
      if (typeof (initState as any).then === "function"){
        (initState as Promise<State>).then(it => {
          state.value = it as UnwrapRef<State>;
          loading.value = false;
          store.state = state.value;
        })
      } else {
        state.value = initState as UnwrapRef<State>;
        loading.value = false;
        store.state = state.value;
      }
    })

    return {loading, state: state as Ref<State>}
  }

  const useStore: () => Required<Store> = () => {
    const store = inject<Store>(key);
    if (store == null) {
      throw new Error("Cannot inject store - it's not provided")
    }
    return store as Required<Store>
  }

  return {provideStore, useStore}
}
